import React, { useState } from 'react';
import '../index.css';
import { Layout, Space, Spin, Alert, Typography, Button, Modal } from 'antd';
import SidebarMenu from '../components/button/slider-menu';
import { shallowEqual, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
// ----------------------------------------------------------------------------------------------------
import SignIn from '../components/auth/signin';
import BaseHeader from '../components/header';
// ----------------------------------------------------------------------------------------------------
// router
import useRoutes from './useRoutes';
// ----------------------------------------------------------------------------------------------------
// images
import balanceFitter from '../assets/images/balance_fitter.png';
import btnFold from '../assets/images/fold_button.png';
// ----------------------------------------------------------------------------------------------------
const { Text, Link } = Typography;
const { Header, Content, Footer, Sider } = Layout;

const SiderMaxWidth = 260;
const SiderMinWidth = 50;
// ----------------------------------------------------------------------------------------------------
const childRenderer = (page, parent, props) => {
  const args = {
    path: [parent, page.path].filter((v) => !!v).join('/'),
  };
  if (page.children && page.children.length) {
    //, args.path
    args.path = args.path + '/*';
    args.children = page.children.map((child) => childRenderer(child));
  }
  if (page.screen) {
    const Elem = page.screen;
    // props
    args.element = <Elem {...props} />;
  }
  return <Route key={page.path} {...args} />;
};

// ----------------------------------------------------------------------------------------------------
/**
 * 프로젝트 Layout 컴포넌트
 * @author
 * */
const BasicLayout = (props) => {
  const { principal } = useSelector((s) => s.auth, shallowEqual);
  const { routes, pages } = useRoutes();
  const navigate = useNavigate();
  const { children, loading, ...rests } = props;

  const [siderFold, setSiderFold] = useState(false);
  const [gModal, setGModal] = useState({
    show: false,
    component: <div>Modal Empty</div>,
  });

  /*
  const {
    token: { colorBgContainer },
  } = theme.useToken();
*/
  return (
    <Layout
      /*
      style={
        {
           height: '100vh',
           width: '100vw',
        }
      }*/
      hasSider
    >
      {principal ? (
        <>
          <Sider
            width={siderFold ? SiderMinWidth : SiderMaxWidth}
            // theme={'light'}
            breakpoint="lg"
            collapsedWidth="0"
            /*
            onBreakpoint={(broken) => {
              console.log('[onBreakpoint]', broken);
            }}
            onCollapse={(collapsed, type) => {
              console.log('[onCollapse]', collapsed, type);
            }}
            */
            style={{
              // align 보다 padding으로 center 처리
              backgroundColor: '#FFFFFF',
              padding: '1rem',
              boxShadow: '0px 4px 16px rgba(165, 163, 174, 0.45)',
              overflow: 'auto',
              height: '100vh',
              position: 'fixed',
            }}
            // hidden={undefined}
          >
            <div
              style={{
                display: 'flex',
                flexDriection: 'row',
                height: '6.4rem',
                padding: '20px 0px 24px 5px',
                alignItems: 'center',
                justifyContent: 'flex-end',
                backgroundImage: `url('${!siderFold && balanceFitter}')`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <Button
                style={{ border: 0 }}
                icon={<img width={24} height={24} src={btnFold} />}
                onClick={(e) => {
                  setSiderFold((prev) => !prev);
                }}
              />
            </div>
            {!siderFold && (
              <SidebarMenu
                {...props}
                items={pages}
                checkedIdx={2} // 첫번째는 section이 있음
                navigate={navigate}
              />
            )}
          </Sider>
          <Layout
            style={{
              marginLeft: (siderFold ? SiderMinWidth : SiderMaxWidth) + 12,
            }}
          >
            <Header
              style={{
                padding: 0,
                margin: '24px 16px 0',
                backgroundColor: '#FFFFFF',
              }}
            >
              <BaseHeader {...props} gModal={gModal} setGModal={setGModal} />
            </Header>
            <Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
              <div
                style={{
                  display: 'flex',
                  // flex: 1,
                  width: '100%',
                  // height: '100%',
                  padding: 24,
                  minHeight: 360,
                  // alignItems: 'center',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                  padding: 0,
                }}
              >
                {/* ---------------------------------------------------------------------------------------------------- */}
                {/* Route Setting */}
                <Routes>
                  {/* home path : heme -> centers */}
                  <Route path={'/'} element={<Navigate to={'/centers'} />} />
                  {pages
                    .filter((v) => !!v.screen)
                    .map((page) =>
                      childRenderer(page, undefined, {
                        ...props,
                        gModal,
                        setGModal,
                      })
                    )}
                </Routes>
                {/* Route Setting */}
                {/* ---------------------------------------------------------------------------------------------------- */}
                {/* Route Setting */}
                {loading && (
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      height: '100%',
                      position: 'absolute',
                      zIndex: 1000,
                      alignItems: 'center',
                      justifyContent: 'center',
                      // backgroundColor: 'rgba(0, 0, 0, .1)',
                    }}
                  >
                    <Spin
                      // tip="Loading"
                      size={'large'}
                      style={{
                        display: 'flex',
                        position: 'absolute',
                      }}
                    />
                  </div>
                )}
              </div>
              {/* footer */}
              <Footer
                style={{
                  textAlign: 'center',
                  // background: 'rgba(115, 103, 240, 0.16)',
                }}
              >
                <Text
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',

                    fontFamily: 'Public Sans',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '1.5rem',
                    lineHeight: '2.2rem',
                    color: '#4B465C',
                  }}
                >
                  COPYRIGHT © 2023
                  <Link
                    href="http://humanb.kr/"
                    target="_blank"
                    style={{
                      marginLeft: '1rem',
                      color: '#7367F0',
                      fontWeight: 600,
                    }}
                  >
                    BALANCE FITTER
                  </Link>
                  , All rights Reserved
                </Text>
              </Footer>
            </Content>
          </Layout>
        </>
      ) : (
        <div
          style={{
            display: 'flex',
            width: '100vw',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SignIn />
        </div>
      )}
      {/* ---------------------------------------------------------------------------------------------------- */}
      {/* modal  */}
      {gModal.show && (
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '130%',
            position: 'absolute',
            zIndex: 1000,
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, .3)',
          }}
        >
          {gModal.component}
        </div>
      )}
      {/* ---------------------------------------------------------------------------------------------------- */}
    </Layout>
  );
};

export default BasicLayout;

{
  /* 
    // <Spin tip="Loading" size={'large'}>
    //   <Alert
    //     message="Alert message title"
    //     description="Further details about the context of this alert."
    //     type="info"
    //   />
    // </Spin> 
*/
}
